import { cmsCLient } from '@/services/axiosConfig'

export interface TradeInData {
  questionsMn: TradeInQuestionnaire
  questionsEn: TradeInQuestionnaire
}
export type GetTradeInRes = TradeInData

export interface TradeInQuestionnaire {
  steps: TradeInStep[]
}
export interface TradeInStep {
  title: string
  body?: string[]
  info?: string
  label?: string
}

export type GetTradeInInfo = () => Promise<GetTradeInRes>

export const getTradeInInfo: GetTradeInInfo = async () => {
  try {
    const response = await cmsCLient.get('/trade-in')
    return response.data.data.attributes
  } catch (e: any) {
    return e.message
  }
}
